import { TestService } from '../../../data/services'
import { Test } from './../../../data/models/test'
import { TestPresenter } from './../../../data/presenters/test'
import { IDataServiceConfig, ModelRepository } from './../../../model-repository'

export const TestConfig: IDataServiceConfig<Test> = {
  service: TestService,
  deps: [ModelRepository],
  endpoint: 'exams/tests?filter[user-id]=:user_id',
  model: Test,
  presenter: TestPresenter,
  backend: 'uncached',
  mappings: [
    {
      classType: 'Test',
      jsonType: 'tests',
      propertyMapping: {
        'config': {
          transform: { toModel: (data) => JSON.parse(data || '{}') }
        },
        'frontendConfig': {
          transform: { toModel: (data) => JSON.parse(data || '{}') }
        }
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/config/services/data/test.config.ts